import React, { useEffect, useState } from "react";
import axios from "axios";
import env from "react-dotenv";
import { useNavigate } from "react-router-dom";
import datacredit from "../../data/dataCredit";
import "./ListCredit.css";

const ListCredit = (props) => {
  const [User] = useState(props.user);
  const [newID, setNewId] = useState();
  const navigate = useNavigate();

  const remainingCredit =
    User.UserRegistration.credito.Monto_Certificado - 4175;

  const filteredCredits = datacredit.filter((data) => {
    return parseInt(data.Pago_Mensual) < parseInt(remainingCredit);
  });

  const obtainId = async () => {
    if (User.UserRegistration.infoUser.id === undefined) {
      try {
        const response = await axios.get(env.REACT_APP_USERID);
        setNewId(response.data.data);
      } catch (err) {
        console.error("Error fetching user ID:", err);
      }
    }
  };

  useEffect(() => {
    props.func(filteredCredits);
  }, [filteredCredits, props]);

  useEffect(() => {
    obtainId();
  }, [newID, obtainId]);

  const handleClick = (event, element) => {
    event.preventDefault();
    const userPass2 = {
      UserRegistration: {
        newID: newID + 1,
        infoUser: { ...User.UserRegistration.infoUser },
        credito: {
          ...User.UserRegistration.credito,
          Monto_Otorgado: element.Monto_Otorgado,
          Monto_Depositado: element.Monto_Depositado,
          Cantidad_Cuotas: element.Cuotas,
          Pago_Mensual: element.Pago_Mensual,
        },
      },
    };
    navigate("/Confirmacion_Info", { state: userPass2 });
  };

  const listItems = filteredCredits.map((element) => (
    <div
      key={element.id}
      className="cardCredit"
      onClick={(event) => handleClick(event, element)}
    >
      <p className="TextCredit">Monto Otorgado: ${element.Monto_Otorgado}</p>
      <p className="TextCredit">
        Monto Depositado: ${element.Monto_Depositado}
      </p>
      <p className="TextCredit">Cantidad Cuotas: {element.Cuotas}</p>
      <p className="TextCredit">Pago Mensual: ${element.Pago_Mensual}</p>
    </div>
  ));

  return <div className="scroll">{listItems}</div>;
};

export default ListCredit;
